import Phaser from "phaser";
import { ENEMY_SHOT_LIFESPAN_MS } from "../config";
import type PlayerCell from "./PlayerCell";

/**
 * A hostile projectile fired by an enemy. Travels in a STRAIGHT line toward
 * where the player was when fired (so it can be dodged), and damages the player
 * on contact. Self-destructs on hit or after its lifespan.
 */
export default class EnemyShot extends Phaser.GameObjects.Sprite {
  private player: PlayerCell;
  private vx: number;
  private vy: number;
  private onHit: () => void;
  private bornAt: number;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    player: PlayerCell,
    speed: number,
    onHit: () => void,
  ) {
    super(scene, x, y, "enemy-shot");
    this.player = player;
    this.onHit = onHit;
    this.bornAt = scene.time.now;
    const angle = Phaser.Math.Angle.Between(x, y, player.x, player.y);
    this.vx = Math.cos(angle) * speed;
    this.vy = Math.sin(angle) * speed;
    scene.add.existing(this);
    this.setDepth(14);
  }

  preUpdate(time: number, delta: number): void {
    super.preUpdate(time, delta);
    if (time - this.bornAt > ENEMY_SHOT_LIFESPAN_MS) {
      this.destroy();
      return;
    }
    const dt = delta / 1000;
    this.x += this.vx * dt;
    this.y += this.vy * dt;

    if (Phaser.Math.Distance.Between(this.x, this.y, this.player.x, this.player.y) <= this.player.stats.radius + 6) {
      this.onHit();
      this.destroy();
    }
  }
}
